import { createBrowserHistory } from 'history';
import { FunnelType } from 'scenes/common/types';
import { route } from './route';

const history = createBrowserHistory({
  basename: process.env.REACT_APP_TAM_JUNCTION_NAME || '/',
});

export const initHistory = () => {
  const { pathname, search } = history.location;
  const policyType = pathname.substring(
    1,
    pathname.lastIndexOf('/') === 0
      ? pathname.length
      : pathname.lastIndexOf('/')
  ) as FunnelType;
  history.push(`${route(policyType, '')}${search}`);
};

export default history;
